__turbopack_context__.v({
  "alignTextCenter": "AudurButton-module-scss-module__7XIJ3G__alignTextCenter",
  "block": "AudurButton-module-scss-module__7XIJ3G__block",
  "button": "AudurButton-module-scss-module__7XIJ3G__button",
  "disabled": "AudurButton-module-scss-module__7XIJ3G__disabled",
  "filled": "AudurButton-module-scss-module__7XIJ3G__filled",
  "large": "AudurButton-module-scss-module__7XIJ3G__large",
  "lightBackground": "AudurButton-module-scss-module__7XIJ3G__lightBackground",
  "loading": "AudurButton-module-scss-module__7XIJ3G__loading",
  "medium": "AudurButton-module-scss-module__7XIJ3G__medium",
  "outlined": "AudurButton-module-scss-module__7XIJ3G__outlined",
  "small": "AudurButton-module-scss-module__7XIJ3G__small",
  "text": "AudurButton-module-scss-module__7XIJ3G__text",
});
